import React from "react";

/**
 * UserMessage - Displays a message from the user
 * @param {Object} message - The user message object
 * @returns {JSX.Element}
 */
const UserMessage = ({ message }) => {
    return (
        <div className="flex justify-end w-full">
            <div className="max-w-[90%] bg-acs-primary-green text-black rounded-2xl rounded-br-sm px-4 py-3 shadow-sm">
                <p className="text-fluid-base whitespace-pre-wrap break-words">
                    {message.content}
                </p>
                <span className="text-[10px] opacity-60 mt-1 block">
                    {new Date(message.timestamp).toLocaleTimeString([], {
                        hour: "2-digit",
                        minute: "2-digit",
                    })}
                </span>
            </div>
        </div>
    );
};

export default UserMessage;
